import EmptyState from "../components/EmptyState";
import { formatCurrency } from "../utils/formatters";

export default function PopularItems({ items }) {
  if (!items?.length) {
    return <EmptyState />;
  }

  return (
    <div className="admin-list">
      {items.map((item) => (
        <article key={`${item.item_name}-${item.location}`}>
          <strong>{item.item_name}</strong>
          <span>
            {item.category} - {item.location}
          </span>
          <span>
            {item.quantity_ordered} sold - {formatCurrency(item.revenue)} - {Number(
              item.percentage_of_sales,
            ).toFixed(1)}%
          </span>
        </article>
      ))}
    </div>
  );
}